import { render, staticRenderFns } from "./myBroker.vue?vue&type=template&id=0bc5b45c&scoped=true&"
import script from "./myBroker.vue?vue&type=script&lang=js&"
export * from "./myBroker.vue?vue&type=script&lang=js&"
import style0 from "./myBroker.vue?vue&type=style&index=0&id=0bc5b45c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5b45c",
  null
  
)

export default component.exports